import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { AbstractControl, FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ValidatorFn } from '@angular/forms';
import { endDateNotBeforeStart } from '../../../../../utils/date-range.validator';
import { markAllAsTouched } from '../../../../../utils/markAllAsTouched';

@Component({
  selector: 'app-edit-experience-modal',
  standalone: true,
  imports: [MatDialogModule, MatFormFieldModule, MatInputModule, MatButtonModule, ReactiveFormsModule, CommonModule, TranslateModule],
  templateUrl: './edit-experience-modal.component.html',
  styleUrl: '../edit-modal.scss'
})
export class EditExperienceModalComponent {

  experienceForm: FormGroup;
  loading: boolean = false;

  // Custom validator to check if the date is valid
  dateValidator: ValidatorFn = (control: AbstractControl): { [key: string]: boolean } | null => {
    const dateValue = control.value;
    const year = new Date(dateValue).getFullYear();
    return isNaN(year) || year.toString().length !== 4 ? { invalidDate: true } : null;
  };

  constructor(
    public dialogRef: MatDialogRef<EditExperienceModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder 
  ) {
    
    this.experienceForm = this.fb.group({
      role: [this.data.experience.role || '', Validators.required ],
      company: [this.data.experience.company || '', Validators.required ],
      startDate: [this.data.experience.start_date || '', [Validators.required, this.dateValidator]],
      endDate: [this.data.experience.end_date || '', [ this.dateValidator]],
      responsibilities: [this.data.experience.responsibilities || '', Validators.required]
    }, { validators: endDateNotBeforeStart });

  }

  close(): void {
    this.dialogRef.close();
  }

  saveEditExperience() {
    if (this.experienceForm.valid) {
        const editedExperience = {
            role: this.experienceForm.get('role')?.value,
            company: this.experienceForm.get('company')?.value,
            start_date: this.experienceForm.get('startDate')?.value,
            end_date: this.experienceForm.get('endDate')?.value,
            responsibilities: this.experienceForm.get('responsibilities')?.value
        };
        this.dialogRef.close(editedExperience);
    } else {
        markAllAsTouched(this.experienceForm); // Mark all fields as touched to show validation errors
    }
  }
}
